import { render } from "./IconPerformance.vue?vue&type=template&id=c4bf1718&ts=true"
import script from "./IconPerformance.vue?vue&type=script&lang=ts"
export * from "./IconPerformance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__